import {Stack, Typography} from '@mui/material'


export function NotFound() {
  return <Stack gap={2} justifyContent="center" alignItems="center" width="100vw" height="100vh">
    <img src="/stdy-symbol.svg" alt="Stdy" height={200}/>

    <Typography variant="h2">Not Found</Typography>
  </Stack>
}


